import { render, staticRenderFns } from "./relatedOffers.vue?vue&type=template&id=5b01b011&"
import script from "./relatedOffers.vue?vue&type=script&lang=js&"
export * from "./relatedOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports